import { actionTypes as reduxForm } from 'redux-form'

import * as app from './App/actionTypes'
import * as auth from './Auth/actionTypes'
import * as balance from './Balance/actionTypes'
import * as _form from './Form/actionTypes'
import * as apiKey from './Form/ApiKey/actionTypes'
import * as changeEmail from './Form/ChangeEmail/actionTypes'
import * as changePassword from './Form/ChangePassword/actionTypes'
import * as deposit from './Form/Deposit/actionTypes'
import * as forgotPassword from './Form/ForgotPassword/actionTypes'
import * as notifications from './Form/Notifications/actionTypes'
import * as preferences from './Form/Preferences/actionTypes'
import * as profile from './Form/Profile/actionTypes'
import * as requestHistory from './Form/RequestHistory/actionTypes'
import * as signup from './Form/Signup/actionTypes'
import * as ticket from './Form/Ticket/actionTypes'
import * as tierTwo from './Form/TierTwo/actionTypes'
import * as twoFactor from './Form/TwoFactor/actionTypes'
import * as whitelistAddress from './Form/WhitelistAddress/actionTypes'
import * as withdrawal from './Form/Withdrawal/actionTypes'
import * as historical from './Historical/actionTypes'
import * as instrument from './Instrument/actionTypes'
import * as order from './Order/actionTypes'
import * as payments from './Payments/actionTypes'
import * as price from './Price/actionTypes'
import * as socket from './Socket/actionTypes'
import * as ticker from './Ticker/actionTypes'
import * as trades from './Trades/actionTypes'
import * as walletLink from './WalletLink/actionTypes'

const form = { ..._form, ...reduxForm }

export {
  apiKey,
  app,
  auth,
  balance,
  changeEmail,
  changePassword,
  deposit,
  forgotPassword,
  form,
  historical,
  instrument,
  notifications,
  order,
  payments,
  preferences,
  price,
  profile,
  requestHistory,
  signup,
  socket,
  ticker,
  ticket,
  tierTwo,
  trades,
  twoFactor,
  walletLink,
  whitelistAddress,
  withdrawal
}
